import React from 'react'
import { DomainsTableColumns } from '../../CrossSaleModal.types'
import { CheckBox, StyledText, Switch, Tooltip } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { TooltipPositionWrapper, TooltipWrapper } from '../Steps.styled'

interface DomainHeaderContentProps {
  cellType: DomainsTableColumns
  status: boolean
  onClick: () => void
  isSelectionDisabled?: boolean
}

export const DomainHeaderContent = ({
  cellType,
  status,
  isSelectionDisabled,
  onClick,
}: DomainHeaderContentProps) => {
  const { t } = useTranslation('general')
  const text = t(`crossSaleModal.domainTableCells.${cellType}`)
  const toolttip = (
    <TooltipWrapper>
      <Tooltip tooltiptContent={t(`crossSaleModal.domainTableCells.${cellType}Tooltip`)} />
    </TooltipWrapper>
  )
  switch (cellType) {
    case 'isSelected':
      return (
        <>
          <CheckBox isChecked={status} onClick={onClick} disabled={isSelectionDisabled} />
          <TooltipPositionWrapper>
            <StyledText variant={'baseBold'}>{text}</StyledText>
            {toolttip}
          </TooltipPositionWrapper>
        </>
      )
    case 'wordpress':
      return (
        <>
          <StyledText variant={'baseBold'}>{text}</StyledText>
          <TooltipPositionWrapper>
            <CheckBox isChecked={status} onClick={onClick} />
            {toolttip}
          </TooltipPositionWrapper>
        </>
      )
    case 'isBzMonitor':
      return (
        <>
          <StyledText variant={'baseBold'}>{text}</StyledText>
          <TooltipPositionWrapper>
            <Switch value={status} onChange={onClick} />
            {toolttip}
          </TooltipPositionWrapper>
        </>
      )
    default:
      return <div></div>
  }
}
